import { EntityTokenType } from '@square/dashboard-data/models/squareup/rolodex/instruments-on-file';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { CardInformation } from '@square/dashboard-data/models/squareup/simple-instrument-store/api/verify-and-link-instrument-request';
import { Entity } from '@square/dashboard-data/models/squareup/simple-instrument-store/api/entity';
import Product from '@square/dashboard-data/models/squareup/simple-instrument-store/api/product';
export default ProtoBaseModel.extend({
  uniqueKey: attr(String),
  product: attr(Product),
  accountOwnerMerchantToken: attr(String),
  owningEntityToken: attr(String),
  owningEntityTokenType: attr(EntityTokenType),
  cardInformation: attr(CardInformation),
  initiatingEntity: attr(Entity)
}).reopenClass({
  url: '/api/v1/instruments/verify-and-link'
});